import { BodyCopy as HecBodyCopy } from "hec/components/ui/body-copy";

import type { RegisteredComponent } from "@builder.io/sdk-react";

// Define the component's prop types
interface BodyCopyProps {
  content: string;
  size?: "small" | "medium" | "large";
  attributes?: {
    className?: string;
    [key: string]: string | number | boolean | undefined;
  };
}

const BodyCopy: React.FC<BodyCopyProps> = ({ content, size, attributes }) => {
  return (
    <HecBodyCopy
      size={size}
      {...attributes}
      data-testid="body-copy-HecBodyCopy"
    >
      {content}
    </HecBodyCopy>
  );
};

export default BodyCopy;

export const BodyCopyDefinition = {
  component: BodyCopy,
  name: "Body Copy",
  noWrap: true,
  inputs: [
    {
      name: "size",
      type: "string",
      enum: ["large", "medium", "small"],
      defaultValue: "large",
    },
    {
      name: "content",
      type: "longText",
      defaultValue: "Body Copy",
    },
  ],
} satisfies RegisteredComponent;
